import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
const ClientTestimonials = ({ themeData }: any) => {
  return (
    <>
      {' '}
      <section className="testimonial-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-title">
                <h2
                  style={{
                    color: `#${themeData?.theme_4?.home?.section_10?.h2color}`,
                  }}
                >
                  {themeData?.theme_4?.home?.section_10?.title}
                </h2>
                <p
                  style={{
                    color: `#${themeData?.theme_4?.home?.section_10?.paracolor}`,
                  }}
                >
                  {themeData?.theme_4?.home?.section_10?.paragraph}
                </p>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <Swiper
              spaceBetween={15}
              navigation={true}
              modules={[Navigation]}
              breakpoints={{
                640: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 3,
                },
              }}
              className="home-slider"
            >
              {themeData?.theme_4?.home?.section_10?.review_card.map(
                (items: any) => {
                  return (
                    <SwiperSlide>
                      <div className="testimonial-card">
                        <div className="profile-user">
                          <a className="profile-user-img">
                            <img
                              src={items.reviewer_pic}
                              className="rounded-circle"
                              alt=""
                            />
                          </a>
                          <div className="profile-user-info">
                            <h6>
                              <a
                                style={{
                                  color: `#${themeData?.theme_4?.home?.section_10?.h2color}`,
                                }}
                              >
                                {items.reviewer_name}
                              </a>
                            </h6>
                            <div className="profile-rating">
                              {/* <span className="secondary-text">
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                            </span> */}
                              <span className="secondary-text">
                                {[...Array(5)].map((_, index) => (
                                  <i
                                    key={index}
                                    className={
                                      index < items.rating
                                        ? 'fas fa-star'
                                        : 'far fa-star'
                                    }
                                  ></i>
                                ))}
                              </span>
                              {/* <span>{items.rating}</span> */}
                            </div>
                          </div>
                        </div>
                        <h5
                          style={{
                            color: `#${themeData?.theme_4?.home?.section_10?.h3color}`,
                          }}
                        >
                          {items.review_highlight}
                        </h5>
                        <p
                          style={{
                            color: `#${themeData?.theme_4?.home?.section_10?.paracolor}`,
                          }}
                        >
                          {items.review}
                        </p>
                      </div>
                    </SwiperSlide>
                  );
                }
              )}
            </Swiper>
          </div>
        </div>
      </section>
    </>
  );
};

export default ClientTestimonials;
